import logo from '../assets/logo/logo.png'
import bancontact from '../assets/logo/bancontact.svg'
import visa from '../assets/logo/visa.svg'
import ideal from '../assets/cover/pay/Apple_Pay.png'
import mastercard from '../assets/logo/mastercard.svg'
import { SITE_INFO } from '../configs/info'

export default function Footer() {

    return (
        <footer className="bg-gray-950 text-gray-100 pt-16">
            <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14 items-start mb-16">
                    {/* Brand + description */}
                    <div className="space-y-5">
                        <div className="flex items-center gap-3">
                            <img src={logo} alt="logo" className="w-12 h-auto" />
                        </div>
                        <p className="leading-relaxed text-gray-200">
                            Ofrecemos servicios de IPTV de alta gama. Nuestro servicio es simple,
                            rápido y confiable. Disfrute de sus canales, películas y series favoritas en todos
                            sus dispositivos, dondequiera que esté.
                        </p>
                    </div>

                    {/* Quick links */}
                    <div>
                        <h3 className="text-xl font-extrabold text-white mb-4">
                            Enlaces rápidos
                        </h3>
                        <ul className="space-y-3 text-gray-100">
                            <li>
                                <a href="/privacy-policy" className="hover:text-orange-400 transition-colors">Política de privacidad</a>
                            </li>
                            <li>
                                <a href="/terms-conditions" className="hover:text-orange-400 transition-colors">Términos y condiciones</a>
                            </li>
                            <li>
                                <a href="/politic-reimbursement" className="hover:text-orange-400 transition-colors">Política de reembolso</a>
                            </li>
                        </ul>
                    </div>

                    {/* Payments */}
                    <div>
                        <h3 className="text-xl font-extrabold text-white mb-4">
                            Aceptamos
                        </h3>
                        <div className="grid grid-cols-4 gap-5">
                            {/* VISA */}
                            <div className="bg-white hover:bg-white/80 duration-500 rounded-md p-2 w-20 h-12 md:w-24 md:h-14 flex items-center justify-center">
                                <img src={visa} alt="Visa" className="w-20 h-auto" />
                            </div>
                            {/* Bancontact */}
                            <div className="bg-white hover:bg-white/80 duration-500 rounded-md p-2 w-20 h-12 md:w-24 md:h-14 flex items-center justify-center">
                                <img src={bancontact} alt="Bancontact" className="w-20 h-auto" />
                            </div>
                            {/* iDEAL */}
                            <div className="bg-white hover:bg-white/80 duration-500 rounded-md p-2 w-20 h-12 md:w-24 md:h-14 flex items-center justify-center">
                                <img src={ideal} alt="Ideal" className="w-20 h-auto" />
                            </div>
                            {/* MasterCard */}
                            <div className="bg-white hover:bg-white/80 duration-500 rounded-md p-2 w-20 h-12 md:w-24 md:h-14 flex items-center justify-center">
                                <img src={mastercard} alt="Mastercard" className="w-20 h-auto" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='text-center text-sm text-gray-200 border-t border-red-500/30 py-4'>
                    <p>Copyright © 2026 {SITE_INFO.siteName}. Todos los derechos reservados.</p>

                </div>
            </div>
        </footer>
    );
}
